import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { withRouter } from 'react-router-dom';
import { take, includes, toArray } from 'lodash';

import { STATIC_ROOT } from '../../../constants';
import { RECHERCHE_VERSION_MENU_MOBILE_SLIDE } from '../../../services/header/constants';

import { toggleMenuMobileSlide } from '../../../services/header/actions';
import { searchInput, searchClear } from '../../../services/search/actions';

import { isSpecificMobileNavOpen } from '../../../services/header/selector';

import { cleanQuery } from '../../../services/search/utils';
import { hasEbonCashback } from '../../../services/partner/utils';

import SvgComponent from '../../SvgComponent';
import { ResultComponent } from './ResultComponent';
import ButtonComponent from '../../button/ButtonComponent';

import { SearchContainer, SearchResults } from './SearchComponentStyle';

const MAX_RESULTS = 12;

class RechercheComponent extends React.Component {
    state = {
        showList: false,
        inputValue: ''
    };

    componentDidMount() {
        document.body.addEventListener('click', this.onClickOutside);
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onClickOutside);
    }

    onClickOutside = event => {
        const container = ReactDOM.findDOMNode(this._wrapper);
        if (container && !container.contains(event.target)) {
            this.setState({ showList: false });
        }
    };

    onClickBtMenuMobile = e => {
        e.preventDefault();
        this.props.toggleMenuMobileSlide(RECHERCHE_VERSION_MENU_MOBILE_SLIDE);
    };

    onChangeInput = event => {
        const inputValue = event.target.value;
        this.setState({ inputValue, showList: inputValue.length > 0 });
    };

    closeList = () => {
        this.setState({ showList: false });
    };

    submitHandler(e) {
        e.preventDefault();
    }

    render() {
        const { i18n, isMenuMobileSearchOpen, ebonPartners } = this.props;

        const value = this.form ? this.form.elements.champrecherche.value : '';

        const filteredEbon = !!value
            ? toArray(ebonPartners).filter(
                  p => includes(cleanQuery(p.name), cleanQuery(value)) && hasEbonCashback(p)
              )
            : [];
        const allPartners = filteredEbon;

        const results = !!value
            ? take(
                  allPartners.sort((a, b) => {
                      const ia = a.name.toLowerCase().indexOf(cleanQuery(value));
                      const ib = b.name.toLowerCase().indexOf(cleanQuery(value));

                      if (ia === ib) {
                          return a.name > b.name;
                      }

                      if (ia === -1) {
                          return 1;
                      }

                      if (ib === -1) {
                          return -1;
                      }

                      return ia - ib;
                  }),
                  MAX_RESULTS
              )
            : [];

        return (
            <SearchContainer
                ref={elt => {
                    this._wrapper = elt;
                }}>
                <div
                    className="champ-recherche-label-mobile champ-recherche-label show-mobonly curpt"
                    id="champ-recherche-label-mobile-bt"
                    onClick={this.onClickBtMenuMobile}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/picto-rechercher.svg`}
                        width="18"
                        height="18"
                    />
                </div>

                <form
                    ref={elt => {
                        this.form = elt;
                    }}
                    onSubmit={this.submitHandler}
                    id="recherche"
                    className={`recherche menu-mobile-slide ${
                        isMenuMobileSearchOpen ? 'open' : ''
                    }`}>
                    <div className="menu-mobile-slide-conteneur posrel">
                        <div className="show-mobonly">
                            <div className="bold flex-container-h flex-center-alt menu-mobile-slide-titre">
                                <div className="champ-recherche-label">
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-rechercher.svg`}
                                        width="18"
                                        height="18"
                                    />
                                </div>
                                {i18n.FINDMERCHANT}
                            </div>
                        </div>

                        <div className="champ-recherche flex-container-h flex-center-alt input">
                            <label
                                className="champ-recherche-label hidden-mobonly"
                                htmlFor="champrecherche">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/picto-rechercher.svg`}
                                    width="18"
                                    height="18"
                                />
                            </label>

                            <MediaQuery query="(min-width: 769px)">
                                {matches => (
                                    <input
                                        type="search"
                                        name="champrecherche"
                                        id="champrecherche"
                                        placeholder={i18n.FINDMERCHANT}
                                        autoComplete="off"
                                        value={this.state.inputValue}
                                        onChange={this.onChangeInput}
                                        onFocus={this.onChangeInput}
                                    />
                                )}
                            </MediaQuery>
                        </div>

                        <div className="show-mobonly">
                            <ButtonComponent
                                text={i18n.SEARCH}
                                color="main"
                                cssClass="w100"
                                onClick={this.onSearch}
                            />
                        </div>
                        {this.state.showList && (
                            <SearchResults>
                                {results.length > 0
                                    ? results.map(r => (
                                          <ResultComponent
                                              key={hasEbonCashback(r) ? `${r.id}-ebon` : r.id}
                                              partner={r}
                                              onClick={this.closeList}
                                          />
                                      ))
                                    : this.state.inputValue && (
                                          <li className="resultat">
                                              <span className="resultat-conteneur flex-container-h flex-center-alt">
                                                  <div>{i18n.NO_MERCHANT}</div>
                                              </span>
                                          </li>
                                      )}
                            </SearchResults>
                        )}
                    </div>
                </form>
            </SearchContainer>
        );
    }
}

RechercheComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => ({
    i18n: state.i18n.feature.header.SEARCH,
    isMenuMobileSearchOpen: isSpecificMobileNavOpen(state, RECHERCHE_VERSION_MENU_MOBILE_SLIDE),
    ebonPartners: state.ebon.ebonPartners
});

const mapDispatchToProps = {
    searchInput,
    searchClear,
    toggleMenuMobileSlide
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RechercheComponent));



// WEBPACK FOOTER //
// ./src/components/header/search/SearchComponent.js